import React from 'react'
import _ from 'lodash'

import BkFlowMaterialLoader  from '../../../elements/BkFlowMaterialLoader'
import BkFlowSideBarPolicyEntries from './elements/BkFlowSidebarPolicyEntries'

const BkFlowSidebarPolicies = props => {
  const {
    configData,
    availabilityLoading,
    activeRoom,
    roomRateDetailsData
  } = props

  const hotelLabels = configData.hotel.labels[0]
  let renderPolicies = null

  if (
    availabilityLoading ||
    roomRateDetailsData.loading
  ) {
    renderPolicies = (
      <BkFlowMaterialLoader
        parentClasses='u-txt-center'
        size={30}
      />
    )
  } else {
    if (activeRoom) {
      let renderRoomPolicies = [],
          roomPoliciesData,
          totalRooms = Object.keys(activeRoom).length

      for (let roomKey in activeRoom) {
        // check initial availabilityData OR additional roomRateDetailsData for cancel policies
        if (!_.isEmpty(activeRoom[roomKey][1][0].viewExtensions.policies)) {
          roomPoliciesData = activeRoom[roomKey][1][0].viewExtensions.policies
        } else if (
          roomRateDetailsData &&
          roomRateDetailsData.roomRateDetails &&
          roomRateDetailsData.roomRateDetails[activeRoom[roomKey][1][0].roomTypeCode + '-' + activeRoom[roomKey][1][0].ratePlanCode + '-' + roomKey] &&
          !_.isEmpty(roomRateDetailsData.roomRateDetails[activeRoom[roomKey][1][0].roomTypeCode + '-' + activeRoom[roomKey][1][0].ratePlanCode + '-' + roomKey].viewExtensions.policies)
        ) {
          roomPoliciesData = roomRateDetailsData.roomRateDetails[activeRoom[roomKey][1][0].roomTypeCode + '-' + activeRoom[roomKey][1][0].ratePlanCode + '-' + roomKey].viewExtensions.policies
        }

        // construct a policies group for each activeRoom
        if (!_.isEmpty(roomPoliciesData)) {
          renderRoomPolicies.push(
            <div
              className="bk-flow-payment__sidebar-policies-group"
              key={ activeRoom[roomKey][1][0].roomTypeCode + '-' + activeRoom[roomKey][1][0].ratePlanCode + '-' + roomKey + '-policies' }
            >
              { totalRooms > 1 ?
                <h4 className="u-remove-margin">{ hotelLabels.room ? hotelLabels.room : 'Room' } { Number(roomKey) + 1 } { hotelLabels.policies ? hotelLabels.policies : 'Policies'}</h4>
              :
                <h4 className="u-remove-margin">{ hotelLabels.roomPolicies ? hotelLabels.roomPolicies : 'Room Policies' }</h4>
              }
              <BkFlowSideBarPolicyEntries
                roomPolicies={roomPoliciesData}
              />
            </div>
          )
        }
      }

      // construct policies block(s) based on policies groups being set from activeRoom(s)
      if (!_.isEmpty(renderRoomPolicies)) {
        renderPolicies = (
          <div className="bk-flow-payment__sidebar-policies">
            <div className="bk-flow-payment__sidebar-policies-content">
              { renderRoomPolicies }
            </div>
          </div>
        )
      }
    }
  }

  return renderPolicies
}

export default BkFlowSidebarPolicies



// WEBPACK FOOTER //
// ./src/components/payment/sidebar/policies/BkFlowSidebarPolicies.js